<div class="item-list-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <clr-alert *ngIf="isFixedNumbers && transactionsExist" [clrAlertType]="'info'" [clrAlertClosable]="false">
    <div class="alert-item">
      <span class="alert-text">
        {{ 'ERRORS.DISTRIBUTION_MANAGEMENT_TRANSACTIONS_EXIST' | translate }}
      </span>
    </div>
  </clr-alert>
  <div class="grid-buttons">
    <dx-button *ngIf="isFixedNumbers" hint="{{ 'SHARED.ADD' | translate }}" icon="add" (onClick)="add()"></dx-button>
    <dx-button hint="{{ 'SHARED.PRINT' | translate }}" icon="print" (onClick)="print()"></dx-button>
  </div>
  <br />
  <dx-data-grid #distributionNumbersGrid id="printSection" [rtlEnabled]="rtlEnabled"
                [dataSource]="distributionNumberDataSource" [showBorders]="true" [allowColumnReordering]="true"
                [hoverStateEnabled]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true" (onRowClick)="edit($event)"
                (onExporting)="onExporting($event)"
                (onEditorPreparing)="onEditorPreparing($event)"
                [remoteOperations]="{ paging: true, filtering: true, sorting: true, search: true }"
                [paging]="{ pageSize: 20 }">

    <dxo-export [enabled]="true"></dxo-export>
    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]"
               [showNavigationButtons]="true" [showInfo]="true"
               infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}">
    </dxo-pager>

    <ng-template #filterRowEditor let-options="options">
      <dx-select-box [dataSource]="buyerDataSource"
                     [value]="options.value"
                     valueExpr="buyerDisplayValue"
                     displayExpr="buyerDisplayValue"
                     [showClearButton]="true"
                     [searchEnabled]="true"
                     (onValueChanged)="options.setValue($event.value)">
      </dx-select-box>
    </ng-template>

    <dxi-column dataType="string"
                name="buyerName"
                dataField="buyerDisplayName"
                calculateDisplayValue="buyerDisplayName"
                caption="{{ 'DISTRIBUTION_MANAGEMENT.BUYER_NAME' | translate }}">
    </dxi-column>

    <dxi-column dataField="masterDataListRowId"
                caption="{{ 'DISTRIBUTION_MANAGEMENT.CATEGORY' | translate }}"
                [editorOptions]="{ showClearButton: true }">
      <dxo-lookup [dataSource]="masterDataLookupSource" valueExpr="value" displayExpr="label">
      </dxo-lookup>
    </dxi-column>

    <dxi-column dataType="number" dataField="value"
                caption="{{ 'DISTRIBUTION_MANAGEMENT.DISTRIBUTION_NUMBER_TITLE' | translate }}"
                [editorOptions]="{ showClearButton: true }">
    </dxi-column>

    <dxi-column *ngIf="isFixedNumbers" dataType="number" dataField="monday"
                caption="{{ 'SHARED.MONDAY' | translate }}"
                [allowEditing]="false" alignment="center" cellTemplate="mondayTemplate">
    </dxi-column>

    <dxi-column *ngIf="isFixedNumbers" dataType="number" dataField="tuesday"
                caption="{{ 'SHARED.TUESDAY' | translate }}"
                [allowEditing]="false" alignment="center" cellTemplate="tuesdayTemplate">
    </dxi-column>

    <dxi-column *ngIf="isFixedNumbers" dataType="number" dataField="wednesday"
                caption="{{ 'SHARED.WEDNESDAY' | translate }}"
                [allowEditing]="false" alignment="center" cellTemplate="wednesdayTemplate">
    </dxi-column>

    <dxi-column *ngIf="isFixedNumbers" dataType="number" dataField="thursday"
                caption="{{ 'SHARED.THURSDAY' | translate }}"
                [allowEditing]="false" alignment="center" cellTemplate="thursdayTemplate">
    </dxi-column>

    <dxi-column *ngIf="isFixedNumbers" dataType="number" dataField="friday"
                caption="{{ 'SHARED.FRIDAY' | translate }}"
                [allowEditing]="false" alignment="center" cellTemplate="fridayTemplate">
    </dxi-column>

    <dxi-column *ngIf="isFixedNumbers" dataType="number" dataField="saturday"
                caption="{{ 'SHARED.SATURDAY' | translate }}"
                [allowEditing]="false" alignment="center" cellTemplate="saturdayTemplate">
    </dxi-column>

    <dxi-column *ngIf="isFixedNumbers" dataType="number" dataField="sunday"
                caption="{{ 'SHARED.SUNDAY' | translate }}"
                [allowEditing]="false" alignment="center" cellTemplate="sundayTemplate">
    </dxi-column>

    <dxi-column type="buttons" [width]="70" [visible]="isFixedNumbers && editingEnabled">
      <dxi-button hint="{{ 'SHARED.EDIT' | translate }}" icon="edit" [onClick]="edit"></dxi-button>
      <dxi-button hint="{{ 'SHARED.DELETE' | translate }}" icon="trash" [onClick]="deleteItem"></dxi-button>
    </dxi-column>
    <div *dxTemplate="let cell of 'mondayTemplate'">
      <div *ngIf="cell.data.monday > 0">
        <label *ngIf="!cell.data.mondayEnabled">
          <s>{{ cell.data.monday }}</s>
        </label>
        <label *ngIf="cell.data.mondayEnabled">
          {{ cell.data.monday }}
        </label>
      </div>
    </div>
    <div *dxTemplate="let cell of 'tuesdayTemplate'">
      <div *ngIf="cell.data.tuesday > 0">
        <label *ngIf="!cell.data.tuesdayEnabled">
          <s>{{ cell.data.tuesday }}</s>
        </label>
        <label *ngIf="cell.data.tuesdayEnabled">
          {{ cell.data.tuesday }}
        </label>
      </div>
    </div>
    <div *dxTemplate="let cell of 'wednesdayTemplate'">
      <div *ngIf="cell.data.wednesday > 0">
        <label *ngIf="!cell.data.wednesdayEnabled">
          <s>{{ cell.data.wednesday }}</s>
        </label>
        <label *ngIf="cell.data.wednesdayEnabled">
          {{ cell.data.wednesday }}
        </label>
      </div>
    </div>
    <div *dxTemplate="let cell of 'thursdayTemplate'">
      <div *ngIf="cell.data.thursday > 0">
        <label *ngIf="!cell.data.thursdayEnabled">
          <s>{{ cell.data.thursday }}</s>
        </label>
        <label *ngIf="cell.data.thursdayEnabled">
          {{ cell.data.thursday }}
        </label>
      </div>
    </div>
    <div *dxTemplate="let cell of 'fridayTemplate'">
      <div *ngIf="cell.data.friday > 0">
        <label *ngIf="!cell.data.fridayEnabled">
          <s>{{ cell.data.friday }}</s>
        </label>
        <label *ngIf="cell.data.fridayEnabled">
          {{ cell.data.friday }}
        </label>
      </div>
    </div>
    <div *dxTemplate="let cell of 'saturdayTemplate'">
      <div *ngIf="cell.data.saturday > 0">
        <label *ngIf="!cell.data.saturdayEnabled">
          <s>{{ cell.data.saturday }}</s>
        </label>
        <label *ngIf="cell.data.saturdayEnabled">
          {{ cell.data.saturday }}
        </label>
      </div>
    </div>
    <div *dxTemplate="let cell of 'sundayTemplate'">
      <div *ngIf="cell.data.sunday > 0">
        <label *ngIf="!cell.data.sundayEnabled">
          <s>{{ cell.data.sunday }}</s>
        </label>
        <label *ngIf="cell.data.sundayEnabled">
          {{ cell.data.sunday }}
        </label>
      </div>
    </div>
  </dx-data-grid>
</div>

<distribution-number-component #details (onClosed)="onDetailsComponentClosed($event)"></distribution-number-component>
<confirmation-component #confirmation title="{{ 'DISTRIBUTION_MANAGEMENT.DELETE' | translate }}"
  message="{{ 'DISTRIBUTION_MANAGEMENT.DELETE_MESSAGE_DISTRIBUTION_NUMBERS' | translate }}"
  buttonCloseText="{{ 'SHARED.DELETE' | translate }}" cancellable="true"
  (close)="deleteSelected();"></confirmation-component>
